import React from 'react';
import { Link } from 'react-router-dom';
import { UserCircle, ArrowRight } from '@phosphor-icons/react';

/**
 * DashboardShortcut — a single glass pill in the bottom-app-bar slot for admin /
 * partner users who wander into the customer-facing mobile frame. Tapping takes
 * them straight back to their own dashboard.
 */
const DashboardShortcut = ({ role }) => {
  const to = role === 'admin' ? '/admin' : '/partner';
  const label = role === 'admin' ? 'Admin Dashboard' : 'Partner Dashboard';
  return (
    <Link
      to={to}
      data-testid="dashboard-shortcut"
      className="absolute bottom-2 left-2 right-2 z-30 rounded-2xl flex items-center gap-3 px-4 py-2.5 transition-transform duration-150 ease-out active:scale-[0.98]"
      style={{
        background: 'color-mix(in srgb, #ffffff 68%, transparent)',
        backdropFilter: 'blur(14px) saturate(180%)',
        WebkitBackdropFilter: 'blur(14px) saturate(180%)',
        border: '1px solid rgba(255, 255, 255, 0.55)',
        boxShadow:
          '0 12px 28px -10px rgba(0, 0, 0, 0.25), 0 2px 4px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255, 255, 255, 0.65)',
      }}
    >
      <div
        className="w-9 h-9 rounded-xl flex items-center justify-center shrink-0"
        style={{ background: 'color-mix(in srgb, var(--pk-primary) 14%, transparent)' }}
      >
        <UserCircle size={22} weight="fill" color="var(--pk-primary)" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-[9px] tracking-[0.22em] uppercase font-bold text-neutral-500">Signed in as {role}</div>
        <div className="font-display text-[14px] leading-tight truncate">{label}</div>
      </div>
      <ArrowRight size={16} weight="bold" style={{ color: 'var(--pk-primary)' }} className="shrink-0" />
    </Link>
  );
};

export default DashboardShortcut;
